<template>
  <div class="top-block">
    <div class="top-block__part">
      <h1 class="top-block__title h1">
        Hi, I’m Soda <br />
        Your safe connect
      </h1>
    </div>
    <div class="top-block__part">
      <div class="top-block__phone-wrapper">
        <DotLottieVue
          class="top-block__phone"
          autoplay
          loop
          src="/animations/homepage.json"
        />
      </div>
    </div>
    <div class="top-block__part">
      <div class="top-block__desc">
        <h3 class="top-block__text h3">
          Mobile app that helps you stay independent online and maintain digital
          safety
        </h3>
        <DownloadLink class="btn_dark" />
      </div>
    </div>
  </div>
</template>

<script setup>
import DownloadLink from './DownloadLink.vue'
</script>
